<template>
	<div class="profile_block">
		<div class="profile_block-logo">
			<img v-if="photo && isErrorFile" :src="photo" :alt="name" @error="onError">
			<svg-sprite v-else width="50" height="50" icon-id="user"></svg-sprite>
		</div>
		<div class="profile_block-wrap">
			<div :title="name" class="profile_block-title">{{ name }}</div>
			<div v-if="manager" :title="manager.department" class="profile_block-title">{{ manager.department }}</div>
			<button v-else @click="onEdit" class="profile_block-btn">Edit password</button>
		</div>
	</div>
</template>

<script>
export default {
	name: "ProfileBlock",
	props: {
		photo: String,
		name: String,
		manager: Object
	},
	data: () => ({
		isErrorFile: true
	}),
	methods: {
		onEdit() {
			this.$emit('updateEdit');
		},
		onError() {
			this.isErrorFile = false;
		}
	}
};
</script>

<style scoped lang="scss">
@import "profileBlock";
</style>
